import { render, staticRenderFns } from "./modal-center.vue?vue&type=template&id=353b21de&scoped=true"
import script from "./modal-center.vue?vue&type=script&setup=true&lang=ts"
export * from "./modal-center.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./modal-center.vue?vue&type=style&index=0&id=353b21de&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353b21de",
  null
  
)

export default component.exports